import styled, { css } from "styled-components";

export const postTitleStyles = css`
  font-size: 58px;
  line-height: 1.05;
  font-family: "GT Sectra", serif;

  @media (max-width: 960px) {
    font-size: 48px;
    margin-bottom: 20px;
  }
`;

export const PostTitle = styled.h1`
  ${postTitleStyles}
  margin: 0;
`;
